<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.code"
                 placeholder="编号"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.title"
                 placeholder="名称"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.tag"
                 placeholder="标签"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Select clearable
              style="width:100px;"
              v-model="search.industryId"
              :label-in-value="true"
              placeholder="行业"
              class="select"
            >
           <Option v-for="(item,index) in this.apiData.industryList" :key="index" :value="item.key" :label="item.name"></Option>
          </Select>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.creater"
                 placeholder="创建者"
                 style="width: 150px;"
          ></Input>
        </div>
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
      </div>
      <div class="search-center">
        <Button
            style="width: 80px;"
            type="primary"
            @click="addTemplate"
        >新增模板
        </Button>
      </div>
    </div>
    <div class="table">
      <Table
          :columns="diyData.columns"
          :data="apiData.tableList"
      >
        <template slot="footer">
          <div class="pagination">
          </div>
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </template>
      </Table>
    </div>

    <!--编辑抽屉-->
    <Drawer title="" width="400" :closable="false" v-model="diyDom.showModal">
      <Form
          ref="editForm"
          :model="form"
          :label-width="100"
      >
        <FormItem label="编码" prop="code">
          <Input
              placeholder="请输入编码"
              v-model="form.code"
              style="max-width:300px;width:100%"
          />
        </FormItem>
        <FormItem label="名称" prop="title">
          <Input
              placeholder="请输入名称"
              v-model="form.title"
              style="max-width:300px;width:100%"
          />
        </FormItem>
        <FormItem label="标签" prop="tag">
          <Input
              placeholder="请输入标签"
              v-model="form.tag"
              style="max-width:300px;width:100%"
          />
        </FormItem>
        <FormItem label="排序" prop="sort">
          <Input
              placeholder="请输入标签"
              v-model="form.sort"
              style="max-width:300px;width:100%"
          />
        </FormItem>
        <FormItem label="图标" prop="icon">
          <div class="upload-Img">
            <div v-if="form.icon" class="look-img">
              <img :src="form.icon" style="width: 100%"/>
              <div class="demo-upload-list-cover">
                <Icon
                    type="ios-eye-outline"
                    @click.native="viewImg(form.icon)"
                ></Icon>
                <Icon
                    type="ios-trash-outline"
                    @click.native="deleteIcon('img',index)"
                ></Icon>
              </div>
            </div>
            <template v-else>
              <Upload
                  :action="uploadUrl"
                  :headers="headers"
                  :on-error="uploadErr"
                  :on-exceeded-size="handleMaxSize"
                  :on-success="(value) => uploadIconSuccess('img', value,index)"
                  name="file"
                  :max-size="2048"
                  :show-upload-list="false"
              >
                <div class="upload-btn">
                  <Icon
                      type="ios-cloud-upload"
                      size="60"
                      style="color: #3399ff"
                  ></Icon>
                </div>
              </Upload>
            </template>
          </div>
        </FormItem>
        <FormItem label="预览图" prop="img">
          <div class="upload-Img">
            <div v-if="form.img" class="look-img">
              <img :src="form.img" style="width: 100%"/>
              <div class="demo-upload-list-cover">
                <Icon
                    type="ios-eye-outline"
                    @click.native="viewImg(form.img)"
                ></Icon>
                <Icon
                    type="ios-trash-outline"
                    @click.native="deletetemplateFile('img',index)"
                ></Icon>
              </div>
            </div>
            <template v-else>
              <Upload
                  :action="uploadUrl"
                  :headers="headers"
                  :on-error="uploadErr"
                  :on-exceeded-size="handleMaxSize"
                  :on-success="(value,file) => uploadtemplateSuccess('img', value,index,file)"
                  name="file"
                  :max-size="2048"
                  :show-upload-list="false"
              >
                <div class="upload-btn">
                  <Icon
                      type="ios-cloud-upload"
                      size="60"
                      style="color: #3399ff"
                  ></Icon>
                </div>
              </Upload>
            </template>
          </div>
        </FormItem>
        <FormItem label="源文件" prop="sourceFile">
          <template v-if="form.sourceFile">
            <span style="margin-left: 10px;color:#2a82e4;cursor: pointer;"
                  @click="lookFile(form.sourceFile)">查看</span>
            <span style="margin-left: 10px;color:#ff0000;cursor: pointer;" @click="deteleSourceFile">删除</span>
          </template>
          <template v-else>
            <Upload
                :action="tempUploadUrl"
                :data="uploadData"
                :before-upload="beforeUpload"
                :on-progress="handleProgress"
                :headers="headers"
                :on-error="uploadErr"
                :on-success="uploadSuccess"
                name="file"
                :show-upload-list="false"
            >
              <Button style="margin-left: 10px" icon="ios-cloud-upload">上传源文件</Button>
            </Upload>
            <!-- 进度条 -->
            <Progress
                v-if="progressPercent >= 0"
                :percent="progressPercent"
                :status="progressStatus"
            />
            <p v-if="progressPercent >= 0">{{ progressPercent }}%</p>
          </template>
        </FormItem>
      </Form>
      <div>
        <Button style="width: 90px" @click="closeModal()">返回</Button>
        <Button type="primary" @click="getEnsure()" style="width: 90px; margin-left: 20px">提交</Button>
      </div>
    </Drawer>

    <!--关联产品抽屉-->
    <!--    <Drawer title="关联产品" width="600" :closable="false" v-model="diyDom.showRelation">-->
    <!--      <img :src="apiData.relationImg" :fit="fit" width="200px" :alt="fit"/>-->
    <!--      <div class="temp-relation" v-for="(item,index) in apiData.bindProductList" :key="index">-->
    <!--        <Select clearable-->
    <!--                style="width:160px;margin-left: 10px"-->
    <!--                v-model="item.productId"-->
    <!--                filterable-->
    <!--                placeholder="请选择产品"-->
    <!--                @on-change="selecTemplateList($event,index)"-->
    <!--        >-->
    <!--          <Option v-for="(items,index) in apiData.productList" :key="index" :value="items.id" :label="items.title">-->
    <!--            <div class="productOption">-->
    <!--              <img :src="items.icon" style="width:40px;height:40px;margin-right: 10px"/>-->
    <!--              {{ items.title }}-->
    <!--            </div>-->
    <!--          </Option>-->
    <!--        </Select>-->
    <!--        <img v-if="item.icon" :src="item.icon" style="width:40px;height:40px;margin-left: 10px"/>-->
    <!--        <img style="width:16px;height:16px;cursor: pointer;margin-left:20px" @click="deleteRalation(index)"-->
    <!--             src="@/assets/images/delete.png">-->
    <!--      </div>-->
    <!--      <Col span="24">-->
    <!--        <div class="add-btn" @click="addProductRelation()">-->
    <!--          增加新模板-->
    <!--        </div>-->
    <!--      </Col>-->
    <!--    </Drawer>-->
    <Modal
        footer-hide
        v-model="diyDom.isModelImg"
        @on-cancel="diyDom.isModelImg=false">
      <img :src="diyDom.imgUrl" style="width: 100%">
    </Modal>

    <!--  关联行业  -->
    <Modal
        title="关联行业"
        footer-hide
        width="400"
        v-model="diyDom.showIndustry"
        @on-cancel="diyDom.showIndustry=false">
      <Transfer
          :list-style="transferStyle"
          :data="apiData.industryList"
          :target-keys="apiData.bindIndustryList"
          :render-format="industryTransferRender"
          @on-change="industryTransferChange"></Transfer>
      <div style="text-align: center;margin-top:10px;">
        <Button style="width: 90px" @click="diyDom.showIndustry=false">取消</Button>
        <Button type="primary" @click="saveTempIndustry()" style="width: 90px; margin-left: 20px">保存</Button>
      </div>
    </Modal>
    <!--  关联产品  -->
    <Modal
        title="关联产品"
        footer-hide
        width="400"
        v-model="diyDom.showProduct"
        @on-cancel="diyDom.showProduct=false">
      <Transfer
          :list-style="transferStyle"
          :data="apiData.productList"
          :target-keys="apiData.bindProductList"
          :render-format="productTransferRender"
          @on-change="productTransferChange"></Transfer>
      <div style="text-align: center;margin-top:10px;">
        <Button style="width: 90px" @click="diyDom.showProduct=false">取消</Button>
        <Button type="primary" @click="saveTempProduct()" style="width: 90px; margin-left: 20px">保存</Button>
      </div>
    </Modal>
    <!-- <ImageViewer
      v-model="diyDom.isModelImg"
      :list="diyData.imgUrl"
      :initial-index="diyData.currentIndex"
    /> -->
  </div>

</template>

<script>
import {
  apiGetOssPolicy,
  apiIndustryAll,
  apiProductAll,
  apiProductRelationDelete,
  apiProductRelationSave,
  apiProducttempDelete,
  apiProducttempInfo,
  apiProducttempList,
  apiProducttempRelation,
  apiProducttempSave,
  apiTempIndustryRelationSave,
  apiTempIndustryRelationSList,
  apiTempProductRelationSave
} from '@/api/template-manage.js'

export default {
  name: 'template-manage',
  data () {
    return {
      headers: {
        token: localStorage.getItem('token')
      },
      uploadUrl: process.env.VUE_APP_API_URL + '/upload-file',
      // tempUploadUrl: process.env.VUE_APP_API_URL + '/producttemp/upload-file',
      client: {
        region: '',
        accessKeyId: '',
        accessKeySecret: '',
        bucket: ''
      },
      tempUploadUrl: '',
      uploadData: {},
      progressPercent: -1, // -1 表示未开始上传
      progressStatus: 'active', // 'active' | 'success' | 'wrong'
      search: {
        title: '',
        code: '',
        tag: '',
        industryId: '',
        pageNo: 1,
        pageSize: 10
      },
      diyDom: {
        showModal: false,
        showIndustry: false,
        imgUrl: '',
        isModelImg: false,
        showProduct: false
      },
      form: {
        id: '',
        code: '',
        title: '',
        tag: '',
        icon: '',
        img: '',
        sourceFile: '',
        imgSize: '',
        sourceSize: '',
        sort: ''
      },
      diyData: {
        iconUrl: '',
        imgUrl: '',
        columns: [
          {
            title: '模板编号',
            key: 'code',
            width: '156px'
          },
          {
            title: '名称',
            width: '100px',
            key: 'title'
          },
          {
            title: '标签',
            width: '240px',
            key: 'tag'
          },
          {
            title: '图标',
            width: '100px',
            render: (h, params) => {
              return h('img', {
                attrs: {
                  src: params.row.icon ? params.row.icon + '?x-oss-process=image/resize,m_fill,w_80' : params.row.icon
                },
                style: {
                  width: '50px'
                },
                on: {
                  click: () => {
                    this.diyDom.isModelImg = true
                    this.diyDom.imgUrl = params.row.icon
                  }
                }
              })
            }
          },
          {
            title: '预览图',
            width: '100px',
            render: (h, params) => {
              return h('img', {
                attrs: {
                  src: params.row.img ? params.row.img + '?x-oss-process=image/resize,m_fill,w_80' : params.row.img
                },
                style: {
                  width: '50px'
                },
                on: {
                  click: () => {
                    this.diyDom.isModelImg = true
                    this.diyDom.imgUrl = params.row.img
                  }
                }
              })
            }
          },
          {
            title: '预览图大小',
            width: '120px',
            render: (h, params) => {
              if (!params.row.imgSize) {
                return h('div', [
                  h('span', '')
                ])
              }
              return h('div', [
                h('span', (params.row.imgSize / 1024 / 1024).toFixed(2) + 'MB')
              ])
            }
          },
          {
            title: '源文件',
            width: '100px',
            key: 'sourceFile',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  style: {
                    fontSize: '14px',
                    with: '80px',
                    display: params.row.sourceFile ? 'inline-block' : 'none'
                  },
                  on: {
                    click: () => {
                      this.lookFile(params.row.sourceFile)
                    }
                  }
                },
                '下载'
                )

              ])
            }
          },
          {
            title: '源文件大小',
            width: '120px',
            render: (h, params) => {
              if (!params.row.sourceFile) {
                return h('div', [
                  h('span', '')
                ])
              }
              return h('div', [
                h('span', (params.row.sourceSize / 1024 / 1024).toFixed(2) + 'MB')
              ])
            }
          },
          {
            title: '关联产品',
            width: '100px',
            key: 'num'
          },
          {
            title: '关联行业',
            width: '100px',
            key: 'industryNum'
          },
          {
            title: '创建者',
            width: '100px',
            key: 'creater'
          },
          {
            title: '创建时间',
            key: 'createTime',
            width: '180px'
          },
          {
            title: '操作',
            width: '180px',
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      apiProducttempRelation({
                        tempId: params.row.id
                      }).then(res => {
                        this.apiData.bindProductList = res.data.map(item => {
                          return item.productId + ''
                        })
                        this.diyDom.showProduct = true
                        this.apiData.tempId = params.row.id

                        // res.data.forEach(item => {
                        //   item.icon = item.icon + '?x-oss-process=image/resize,m_fill,w_40'
                        // })
                        // this.diyDom.showProduct = true
                        // this.apiData.bindProductList = res.data
                        // this.apiData.tempId = params.row.id
                        // this.apiData.relationImg = params.row.img
                      })
                    }
                  }
                },
                '关联产品'
                ),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      this.diyData.id = params.row.id
                      apiProducttempInfo({
                        id: params.row.id
                      }).then(res => {
                        this.form = {
                          id: res.data.info.id,
                          code: res.data.info.code,
                          title: res.data.info.title,
                          tag: res.data.info.tag,
                          icon: res.data.info.icon,
                          img: res.data.info.img,
                          sourceFile: res.data.info.sourceFile,
                          imgSize: res.data.info.imgSize,
                          sourceSize: res.data.info.sourceSize,
                          sort: res.data.info.sort
                        }
                        this.diyDom.showModal = true
                        this.progressPercent = -1 // -1 表示未开始上传
                        this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
                      })
                    }
                  }
                },
                '编辑'
                ),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      this.apiData.tempId = params.row.id
                      this.diyDom.showIndustry = true
                      apiTempIndustryRelationSList({
                        tempId: params.row.id
                      }).then(res => {
                        this.apiData.bindIndustryList = res.data.map(item => {
                          return item + ''
                        })
                      })
                    }
                  }
                },
                '关联行业'
                ),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除？',
                        onOk: () => {
                          apiProducttempDelete({
                            id: params.row.id
                          }).then(res => {
                            this.$Message.success('操作成功')
                            this.getTableList()
                          })
                        }
                      })
                    }
                  }
                },
                '删除'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        infor: null,
        tableList: [],
        productAllTag: [],
        TenplateList: [],
        productList: [],
        bindProductList: [],
        tempId: '',
        relationImg: '',
        industryList: [],
        bindIndustryList: []
      },
      transferStyle: {
        width: '153px',
        height: '500px'
      }
    }
  },
  methods: {
    async beforeUpload (file) {
      try {
        // 正确调用方式：使用 await
        const res = await apiGetOssPolicy({ fileName: file.name })

        this.tempUploadUrl = 'https://muyingad.oss-cn-chengdu.aliyuncs.com'
        this.uploadData = {
          OSSAccessKeyId: res.data.OSSAccessKeyId,
          key: res.data.key,
          policy: res.data.policy,
          signature: res.data.signature,
          success_action_status: '200'
        }

        return true
      } catch (error) {
        console.error('生成签名 URL 失败:', error)
        return false
      }
    },
    // 保存产品
    saveTempProduct () {
      apiTempProductRelationSave({
        tempId: this.apiData.tempId,
        productList: this.apiData.bindProductList
      }).then(res => {
        this.$Message.success('保存成功')
      })
    },
    // 保存行业
    saveTempIndustry () {
      apiTempIndustryRelationSave({
        tempId: this.apiData.tempId,
        industryList: this.apiData.bindIndustryList
      }).then(res => {
        this.$Message.success('保存成功')
      })
    },
    // 添加模板
    addProductRelation () {
      console.log('addProductRelation')
      var obj = {
        id: '',
        productId: '',
        tempId: this.apiData.tempId,
        productName: '',
        icon: ''
      }
      this.apiData.bindProductList.push(obj)
    },
    industryTransferRender (item) {
      return item.name
    },
    productTransferRender (item) {
      return item.title
    },
    industryTransferChange (newTargetKeys, direction, moveKeys) {
      this.apiData.bindIndustryList = newTargetKeys
    },
    productTransferChange (newTargetKeys, direction, moveKeys) {
      this.apiData.bindProductList = newTargetKeys
    },
    getProductList () {
      apiProductAll().then(res => {
        this.apiData.productList = res.data.map(item => {
          item.key = item.id.toString()
          item.title = item.title
          item.icon = item.icon + '?x-oss-process=image/resize,m_fill,w_40,h_40'
          return item
        })
      })
    },
    getIndustryList () {
      apiIndustryAll().then(res => {
        res.data.forEach((item, index) => {
          this.apiData.industryList.push({
            key: item.id.toString(),
            name: item.name
          })
        })
      })
    },
    addTemplate () {
      this.diyDom.showModal = true
      this.progressPercent = -1 // -1 表示未开始上传
      this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
      this.form = {
        id: '',
        code: '',
        title: '',
        tag: '',
        icon: '',
        img: '',
        sourceFile: '',
        imgSize: '',
        sourceSize: '',
        sort: ''
      }
    },
    // 分页
    pageChange (e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange (e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.pageNo = 1
      this.getTableList()
    },
    addPRoduct () {
      this.$router.push({
        name: 'add-product'
      })
    },
    getTableList () {
      this.$store.commit('setSpinShow', true)
      var opt = { ...this.search }
      apiProducttempList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },

    // 模板文件上传成功
    uploadIconSuccess (type, res, index = 0) {
      if (res.code != 200) {
        return this.$Modal.error({ title: '提示', content: res.msg })
      }
      this.$Message.success('文件上传成功')
      this.form.icon = res.data.fileUrl
    },
    deleteIcon (type, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除文件？',
        onOk: () => {
          this.form.icon = ''
        }
      })
    },
    uploadtemplateSuccess (type, res, index = 0, file) {
      if (res.code != 200) {
        return this.$Modal.error({ title: '提示', content: res.msg })
      }
      this.$Message.success('文件上传成功')
      this.form.imgSize = file.size
      this.form.img = res.data.fileUrl
    },
    deletetemplateFile (type, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除文件？',
        onOk: () => {
          this.form.img = ''
        }
      })
    },
    // 文件上传失败
    uploadErr () {
      this.$Spin.hide()
      this.progressStatus = 'wrong'
      this.$Modal.error({
        title: '提示',
        content: '文件上传失败，请重试'
      })
    },
    handleMaxSize () {
      this.$Modal.error({
        title: '错误',
        content: '文件大小超过2M!'
      })
    },
    // 查看文件
    viewImg (url) {
      this.diyDom.isModelImg = true
      this.diyDom.imgUrl = url
    },
    // 查看文件
    lookFile (url) {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.target = '_blank'
      a.href = url
      a.click()
      document.body.removeChild(a)
    },
    // 删除文件
    deleteFile (type, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除文件？',
        onOk: () => {
          if (type == 'sourceFile') {
            this.form.sourceFile = ''
          }
        }
      })
    },
    deteleSourceFile () {
      this.form.sourceFile = ''
      this.progressPercent = -1 // -1 表示未开始上传
      this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
    },
    // 上传进度回调
    handleProgress (event, file, fileList) {
      if (event.lengthComputable) {
        this.progressPercent = Math.floor((event.loaded / event.total) * 100)
      }
    },
    uploadSuccess (res, file, fileList) {
      console.log('res:', res, file)
      this.$Message.success('文件上传成功')
      this.progressStatus = 'success'
      this.form.sourceFile = this.tempUploadUrl + '/' + this.uploadData.key
      this.form.sourceSize = file.size
    },
    closeModal () {
      this.diyDom.showModal = false
      this.progressPercent = -1 // -1 表示未开始上传
      this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
      this.form = {
        id: '',
        code: '',
        title: '',
        tag: '',
        icon: '',
        img: '',
        sourceFile: '',
        imgSize: '',
        sourceSize: '',
        sort: ''
      }
    },
    getEnsure () {
      if (!this.form.img) {
        this.form.imgSize = 0
      }
      if (!this.form.sourceFile) {
        this.form.sourceSize = 0
      }
      var opt = {
        ...this.form
      }
      apiProducttempSave(opt).then(res => {
        this.$Message.success(opt.id ? '修改成功' : '新增成功')
        this.closeModal()
        this.getTableList()
      })
    },
    saveIndustry () {
      var param = {
        tempId: this.form.id,
        industryIds: this.apiData.bindIndustryList
      }
    },
    selecTemplateList (e, index) {
      var that = this
      if (e) {
        this.apiData.productList.forEach(v => {
          if (v.id === e) {
            console.log(v)
            this.apiData.bindProductList[index].productId = v.id
            this.apiData.bindProductList[index].productName = v.title
            this.apiData.bindProductList[index].icon = v.icon

            var param = {
              id: this.apiData.bindProductList[index].id,
              productId: v.id,
              tempId: this.apiData.bindProductList[index].tempId
            }
            apiProductRelationSave(param).then(res => {
              this.apiData.bindProductList[index].id = res.data.id
              this.$Message.success(param.id ? '修改成功' : '新增成功')
            })
          }
        })
      } else {
        this.apiData.bindProductList[index].productName = ''
        this.apiData.bindProductList[index].icon = ''
      }
    },
    deleteRalation (index) {
      let id = this.apiData.bindProductList[index].id
      this.apiData.bindProductList.splice(index, 1)
      if (id) {
        apiProductRelationDelete(id).then(res => {
          this.$Message.success('删除成功')
        })
      }
    }

  },
  mounted () {
    this.getTableList()
    this.getProductList()
    this.getIndustryList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.button-border {
  margin-right: 10px;

}

.tag {
  width: 50px;
  height: 26px;
  opacity: 1;
  border-radius: 5px;
  background: rgba(255, 87, 51, 1);
  text-align: center;
  line-height: 26px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-left: 10px;
  display: inline-block;
}

.upload-Img {
  width: 120px;
  height: 120px;

  .look-img {
    margin-left: 0px;
    width: 120px;
    height: 120px;

    img {
      margin-left: 0px;
    }

    .demo-upload-list-cover {
      line-height: 120px;
    }

    .demo-upload-list-cover i {
      line-height: 120px;
    }
  }

  .upload-Img {
    .demo-upload-list-cover i {
      line-height: normal;
    }
  }

  .upload-btn {
    padding-top: 25px;
    width: 120px;
    height: 120px;
  }
}

.temp-relation {
  width: 100%;
  display: flex;
  padding: 10px 0px;
  align-items: center;

  .upload-Img {
    width: 40px;
    height: 40px;

    .look-img {
      margin-left: 0px;
      width: 40px;
      height: 40px;

      img {
        margin-left: 0px;
      }

      .demo-upload-list-cover {
        line-height: 40px;
      }

      .demo-upload-list-cover i {
        line-height: 40px;
      }
    }

    .upload-Img {
      .demo-upload-list-cover i {
        line-height: normal;
      }
    }

    .upload-btn {
      padding-top: 5px;
      width: 40px;
      height: 40px;
    }
  }
}

.add-btn {
  margin-left: 10px;
  padding: 10px 0px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: rgba(42, 130, 228, 1);
}

.productOption {
  width: 100%;
  display: flex;
  align-items: center;
}
</style>
